import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const LockDocument = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.426,16v-1.748c0-1.808-1.471-3.279-3.279-3.279c-1.809,0-3.279,1.471-3.279,3.279V16h-1.619v7h10 v-7H19.426z M14.868,14.252c0-0.706,0.574-1.279,1.279-1.279c0.705,0,1.279,0.574,1.279,1.279V16h-2.559V14.252z M19.249,21h-6v-3h6 V21z" }),
    React.createElement("polygon", { points: "7.398,21.176 2.751,21.176 2.751,1 19.259,1 19.259,8.313 17.259,8.313 17.259,3 4.751,3 4.751,19.176 7.398,19.176" })), 'LockDocument');
export default LockDocument;
